/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_What_P4Inputs */

const en_home_what_p4 = /** @type {(inputs: Home_What_P4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft AI at cadcraft.org is an independent guide to the project. Here you will find a step-by-step CADCraft download guide, a hosted copy of CADCraft online, beginner tutorials and an honest comparison with AutoCAD.`)
};

/**
* | output |
* | --- |
* | "CADCraft AI at cadcraft.org is an independent guide to the project. Here you will find a step-by-step CADCraft download guide, a hosted copy of CADCraft onli..." |
*
* @param {Home_What_P4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_what_p4 = /** @type {((inputs?: Home_What_P4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_What_P4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_what_p4(inputs)
});
export { home_what_p4 as "home.what.p4" }